<template>
  <div class="box1 text-secondary-1 q-pl-lg">
    <Grid gtc="1fr auto" class="with-separator q-pb-sm">
      <div class="text-body-3">Forecasted cost</div>
      <div class="text-subtitle-1">
        {{ total }} <small>{{ settings.currency }}</small>
      </div>
    </Grid>

    <Grid gtc="1fr auto" class="q-mt-sm">
      <div class="text-caption-3">Received prices</div>
      <div class="text-body-1">
        {{ data && formatPrice(data.received_prices_sum) }} <small>{{ settings.currency }}</small>
      </div>
    </Grid>

    <Grid gtc="1fr auto" class="q-mt-sm">
      <div class="text-caption-3">Forecasted prices</div>
      <div class="text-body-1">
        {{ data && formatPrice(data.forecasted_prices_sum) }} <small>{{ settings.currency }}</small>
      </div>
    </Grid>

    <Grid gtc="1fr auto" class="with-separator q-pb-sm q-mt-sm">
      <div class="text-caption-3">
        Missing prices <br />
        (last year prices)
      </div>
      <div class="text-body-1">
        {{ data && formatPrice(data.missing_prices_sum) }} <small>{{ settings.currency }}</small>
      </div>
    </Grid>

    <Grid gtc="1fr auto" class="q-mt-sm text-grey1">
      <div class="text-caption-3">
        Last year cost
      </div>
      <div class="text-body-1">
        {{ data && formatPrice(data.last_year_cost) }} <small>{{ settings.currency }}</small>
      </div>
    </Grid>
  </div>
</template>

<script>
export default {
  props: {
    data: { required: true }
  },

  computed: {
    total() {
      if (!this.data) return this.formatPrice(0)
      const received = Number(this.data.received_prices_sum)
      const forecasted = Number(this.data.forecasted_prices_sum)
      const missing = Number(this.data.missing_prices_sum)

      return this.formatPrice(received + forecasted + missing)
    }
  }
}
</script>

<style lang="scss" scoped>
.with-separator {
  border-bottom: 1px solid var(--r-white-5);
}
</style>
